module.exports = __webpack_public_path__ + "img/OCBC0229.cded9f7b.png";